import { Controller } from "@hotwired/stimulus"

// Reloads the PV page while the AI commentary is being written in the
// background, and gives up with a message after a while.
const INTERVAL_MS = 5000
const TIMEOUT_MS = 120000

export default class extends Controller {
  static targets = ["pending", "timeout"]
  static values = { startedAt: Number }

  connect() {
    if (Date.now() - this.startedAtValue * 1000 > TIMEOUT_MS) {
      this.pendingTarget.classList.add("d-none")
      this.timeoutTarget.classList.remove("d-none")
      return
    }

    this.timer = setTimeout(() => window.Turbo.visit(window.location.href, { action: "replace" }), INTERVAL_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
